import React, { useRef, useState, useEffect } from 'react'
import {
  withSitecoreContext,
  RichText,
  isEditorActive,
  Link,
} from '@sitecore-jss/sitecore-jss-react'
import Slider from 'react-slick'
import { HighlightsModel } from './models/Highlights.model'
import { HighlightsProps } from './types/Highlights.types'
import LazySection from '../../react-only-components/LazySection'
import { forceVisible } from 'react-lazyload'
import CarouselDots from '../../react-only-components/CarouselDots'
import './index.scss'
import { LinkField } from '../../types/types'

const Highlights = (props: HighlightsProps) => {
  const isEE = props.sitecoreContext?.pageEditing
  const model = new HighlightsModel(props)
  const HighlightsCardList = props?.fields?.highlights
  const [dynamicHeight, setDynamicHeight] = useState(300)
  const widthRef = useRef<HTMLDivElement>(null);
  const [width, setWidth] = useState(0)

  useEffect(() => {
    handleFirstComponentMargin()
    getCurrentWidthAndHeight()
    forceVisible()
  }, [])

  useEffect(() => {
    if (typeof window !== 'undefined' && 'customElements' in window) {
      import('@patternfly/pfe-icon-onhighway/dist/pfe-icon.js');
    }
  }, []);

  useEffect(() => {
    handleDynamicHeight()
    // Update 'width' and 'height' when the window resizes
    window && window.addEventListener('resize', getCurrentWidthAndHeight)
    // return () => window.removeEventListener("resize", getCurrentWidthAndHeight)
  })

  // Add Id to the first component
  const handleFirstComponentMargin = () => {
    let main = document && document.querySelector('main')
    let section = main && main.getElementsByTagName('section')
    if (section && section.length > 0) {
      let style = section[0].setAttribute('name', 'marginHighlights')
    }
    if (isEditorActive() || isEE) {
      let EEMargin = document?.querySelector('main')?.setAttribute('id', 'EEMargin');
      let setMargin = document && document.getElementById('EEMargin')
      if (setMargin) {
        let style = setMargin.setAttribute(
          'style',
          'margin-top: 0px !important'
        )
      }
    }
  }

  // calculate dynamic height
  const handleDynamicHeight = () => {
    let getDynamicHeight =
      document && document.getElementsByName('marginHighlights')[0]?.offsetHeight
    if (getDynamicHeight !== null) {
      setDynamicHeight(getDynamicHeight)
    }
  }

  const getCurrentWidthAndHeight = () => {
    let currentWidth = widthRef?.current?.clientWidth
    if (currentWidth) {
      setWidth(currentWidth as number)
    }
    handleDynamicHeight()
  }

  let desktopPosition = 192
  let tabletPosition = dynamicHeight + 190 - 300
  let mobilePosition = dynamicHeight + 131 - 15
  let smallMobilePosition = -15
  let topValue =
    width >= 1025
      ? desktopPosition
      : width <= 1024 && width >= 768
      ? tabletPosition
      : width <= 767 && width >= 0
      ? smallMobilePosition
      : dynamicHeight

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    arrows: false,
    customPaging: (_) => (
      <a>
        <CarouselDots />
      </a>
    ),
  }
  return (
    <div
      className="Highlights__Position--Wrapper"
      ref={widthRef}
      id={props?.rendering?.uid}
    >
      {props.fields && HighlightsCardList && (
        <LazySection height={50}>
          <div
            className={` ${
              isEditorActive() || isEE ? 'Highlights__EEActive' : ''
            } Highlights__Wrapper`}
            style={{ top: `${topValue}px` }}
          >
            <div className={'Highlights__root'}>
              <RichText
                tag="p"
                field={props?.fields?.title}
                className={'Highlights__Heading'}
              />
              <Slider {...settings}>
                {HighlightsCardList.map((item, index: number) => (
                  <div key={index} className="Highlights__SliderRoot">
                    <Link
                      field={item?.fields?.targetlink as LinkField}
                      className="Highlights__Link"
                    >
                      <RichText
                        tag="p"
                        field={item?.fields?.subtitle}
                        className={'Highlights__Subtitle'}
                      />
                      <div className="Highlights__TitleWrapper">
                        <RichText
                          field={item?.fields?.title}
                          tag="span"
                          className={'Highlights__Title'}
                        />
                        {item?.fields?.title && (
                          <span className="link-with-arrow link-with-arrow--text Highlights__Arrow">
                            <pfe-icon
                              icon="cnh-arrow-forward"
                              size={'18'}
                              color={'complement'}
                            />
                          </span>
                        )}
                      </div>
                    </Link>
                  </div>
                ))}
              </Slider>
            </div>
          </div>
        </LazySection>
      )}
    </div>
  )
}
export default withSitecoreContext()(Highlights)
